export const ProductCard = ({ name, shortName, description, disclaimer, status, accent = "copper", testId }) => {
  const dotClass = accent === "purple" ? "af-status-dot purple" : accent === "muted" ? "af-status-dot muted" : "af-status-dot";

  return (
    <article className="af-card flex flex-col h-full" data-testid={testId}>
      <div className="flex items-center gap-3" style={{ marginBottom: 18 }}>
        {/* Text-only logo fallback (no logo assets found in /app) */}
        <div className="af-logo-fallback" aria-hidden data-testid={`${testId}-logo-fallback`}>
          {shortName}
        </div>
        <h3 style={{ color: "#fff", fontSize: "1.1rem", fontWeight: 700, letterSpacing: "-0.01em", lineHeight: 1.25 }}>
          {name}
        </h3>
      </div>

      <div className="af-body" style={{ color: "#cfd3dc", whiteSpace: "pre-line", marginBottom: disclaimer ? 16 : 20 }}>
        {description}
      </div>

      {disclaimer && (
        <div
          data-testid={`${testId}-disclaimer`}
          style={{
            fontSize: "0.85rem",
            lineHeight: 1.55,
            color: "var(--af-text-muted)",
            borderLeft: "2px solid var(--af-border-strong)",
            paddingLeft: 12,
            marginBottom: 20,
          }}
        >
          {disclaimer}
        </div>
      )}

      <div style={{ marginTop: "auto" }}>
        <span className="af-status" data-testid={`${testId}-status`}>
          <span className={dotClass} aria-hidden />
          {status}
        </span>
      </div>
    </article>
  );
};

export default ProductCard;
